const ActionTypes = {
  RECEIVED_MESSAGE: 'RECEIVED_MESSAGE',
  RECEIVED_MESSAGES: 'RECEIVED_MESSAGES',
  SEND_NEW_MESSAGE: 'SEND_NEW_MESSAGE',
  SUBSCRIBED_CHANNEL: 'SUBSCRIBED_CHANNEL',
  UNSUBSCRIBED_CHANNEL: 'UNSUBSCRIBED_CHANNEL',
  UNSUBSCRIBED_CHANNELS: 'UNSUBSCRIBED_CHANNELS',
  RECEIVED_MESSAGE_UPDATE: 'RECEIVED_MESSAGE_UPDATE',
  PRESENCE_UPDATE: 'PRESENCE_UPDATE',
};

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/ducks/chat/actionTypes.js